import type { Geometry } from "geojson";

export interface ZipcodeMarketValue {
  zipcode: string;
  market_value_electrical: number | null;
  market_value_plumbing: number | null;
  market_value_hvac: number | null;
  market_value_roofing: number | null;
  geometry: Geometry | null;
}

export interface FetchZipcodeMarketValuesRequest {
  zipcodes: string[];
}

export interface FetchZipcodeMarketValuesResponse {
  data: ZipcodeMarketValue[];
}

export type TradeType = "electrical" | "plumbing" | "hvac" | "roofing";

export const TRADE_OPTIONS: { value: TradeType; label: string }[] = [
  { value: "hvac", label: "HVAC" },
  { value: "electrical", label: "Electrical" },
  { value: "plumbing", label: "Plumbing" },
  { value: "roofing", label: "Roofing" },
];

export const getMarketValueKey = (
  trade: TradeType,
): keyof ZipcodeMarketValue => {
  return `market_value_${trade}` as keyof ZipcodeMarketValue;
};
